export default "__VITE_ASSET__BRBcvent__"